/**
 * LAS IMAGENES DE CADA VOZ.
 *
 * Regla del sistema: la imagen de una entidad SIEMPRE llega en el color de su
 * rayo. Por eso NO pasa por Deep Art Effects — ese filtro reasigna los colores
 * a su antojo (en la carpeta del Drive, el estilo «Oil Painting» convirtio a
 * Jeshua en azul y naranja). La imagen se genera directamente con IA, ya en el
 * color correcto, o se deja que el sitio dibuje la luz de la voz.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * 🔴 DOS REGISTROS, Y NO ES DUPLICAR: SON DOS PERMISOS DISTINTOS.
 *
 * Faina, 29-ago, en dos frases: «lo primero es que NO CAMBIES NINGUN ICONO que
 * ya estaba definido» y «la unica imagen que vamos a insertar por el momento es
 * la del mensaje del dia».
 *
 * Y hacia falta decirlo porque yo lo habia roto sin querer: al registrar las
 * fotos en `IMAGENES_VOZ` cambiaron de golpe TRES sitios —las tarjetas de la
 * portada, la pagina de Voces y la cuadricula de la Biblioteca—, porque los tres
 * preguntan por ese mismo mapa. Los catorce emblemas costaron cuatro rondas de
 * eleccion y no se tocan.
 *
 *   IMAGENES_VOZ  →  vacio a proposito. Mientras lo este, TODO el sitio dibuja
 *                    el emblema. El dia que haya retratos definitivos y Faina
 *                    los quiera en las tarjetas, se llena aqui y se encienden
 *                    los tres sitios a la vez.
 *   FOTOS_VOZ     →  las de trabajo, y las usa UN SOLO SITIO: el circulo del
 *                    mensaje del dia. Ahi es donde el lector decide si se queda,
 *                    y una cara mira donde un simbolo no.
 * ══════════════════════════════════════════════════════════════════════════
 *
 * 🔶 LAS FOTOS SON PROVISIONALES: «la vamos a ir ordenando cuando tengamos
 * imagenes definitivas». Salen de `H:\Mi unidad\JESHUA\IMAGENES Y FOTOS`.
 *
 * ⚠️ SON COPIAS: el Drive no se toca (regla del proyecto). El original sigue
 * donde estaba; aqui vive una version de trabajo — WebP 640x640, recortada en
 * cuadrado con el encuadre propio de cada voz. De 2,2 MB a decenas de KB: se
 * ven justo cuando alguien va a leer, asi que no pueden hacer esperar.
 * La receta esta en `herramientas/imagenes_voces.py`.
 *
 * ⚠️ FALTAN DOS y no es un olvido: **Los Angeles** y **Los Esenios** no tienen
 * carpeta en el Drive. Son voces colectivas, asi que puede que nunca la tengan;
 * su dia, el mensaje enseña su emblema.
 *
 * Medida recomendada para las definitivas: 2400 x 1000, con la figura o la
 * fuente de luz arriba y espacio libre abajo, porque el nombre de la voz se
 * apoya en el borde inferior.
 */

/** Vacio a proposito: los emblemas mandan en las tarjetas. Ver arriba. */
export const IMAGENES_VOZ = {};

/** Solo para el circulo del mensaje del dia. */
export const FOTOS_VOZ = {
  'Jeshua': require('../assets/voces/jeshua.webp'),
  'María': require('../assets/voces/maria.webp'),
  'María Magdalena': require('../assets/voces/magdalena.webp'),
  'Ana': require('../assets/voces/ana.webp'),
  'Miguel': require('../assets/voces/miguel.webp'),
  'Gabriel': require('../assets/voces/gabriel.webp'),
  'Rafael': require('../assets/voces/rafael.webp'),
  'Uriel': require('../assets/voces/uriel.webp'),
  'Chamuel': require('../assets/voces/chamuel.webp'),
  'Jofiel': require('../assets/voces/jofiel.webp'),
  'Zadquiel': require('../assets/voces/zadquiel.webp'),
  'Metatrón': require('../assets/voces/metatron.webp')
};

export const tieneImagen = (entidad) => Boolean(IMAGENES_VOZ[entidad]);
